import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, animate = true }) => (
    <div className={className}>
        {lines.map((line, i) => (
            <motion.span
                key={i}
                className="block overflow-hidden pb-[0.08em] -mb-[0.08em]"
                initial="hidden"
                {...(animate
                    ? { animate: "visible" }
                    : { whileInView: "visible", viewport: { once: true, margin: "-60px" } })}
            >
                <motion.span
                    className={`block ${lineClassName}`}
                    variants={{
                        hidden: { y: "115%" },
                        visible: { y: "0%", transition: { duration: 0.9, delay: delay + i * 0.12, ease: EASE } },
                    }}
                >
                    {line}
                </motion.span>
            </motion.span>
        ))}
    </div>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 40 }) => (
    <motion.div
        initial={{ y, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Chapter = ({ index, label, title, dark = false, note }) => (
    <div className="mb-14 md:mb-20">
        <FadeUp>
            <div className="flex items-center gap-4 mb-6">
                <span
                    className={`font-display text-sm tracking-[0.3em] ${
                        dark ? "text-white/50" : "text-slate-400"
                    }`}
                >
                    {index}
                </span>
                <span className={`h-px w-12 ${dark ? "bg-white/30" : "bg-slate-300"}`} />
                <span
                    className={`text-xs font-semibold uppercase tracking-[0.3em] ${
                        dark ? "text-accent" : "text-accent"
                    }`}
                >
                    {label}
                </span>
            </div>
        </FadeUp>
        <MaskedLines
            animate={false}
            lines={Array.isArray(title) ? title : [title]}
            className={`font-display font-semibold tracking-tight text-4xl md:text-5xl lg:text-6xl ${
                dark ? "text-white" : "text-navy"
            }`}
        />
        {note && (
            <FadeUp delay={0.2}>
                <p className={`mt-6 max-w-xl text-base md:text-lg leading-relaxed ${dark ? "text-white/60" : "text-slate-500"}`}>
                    {note}
                </p>
            </FadeUp>
        )}
    </div>
);
